export function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
export function safeParse(str, validate, fallback) {
    try {
        const parsed = JSON.parse(str);
        const result = validate.safeParse(parsed);
        if (result.success) {
            return result.data;
        }
        console.error('Failed to safely parse JSON (schema error)', result.error);
        return fallback;
    }
    catch (e) {
        console.error('Failed to safely parse JSON (JSON.parse error)', e);
        return fallback;
    }
}
// like safeParse but returns undefined when fails
export function safeParseMaybe(str, validate) {
    try {
        const parsed = JSON.parse(str);
        const result = validate.safeParse(parsed);
        if (result.success) {
            return result.data;
        }
        console.error('Failed to safely parse JSON (schema error)', result.error);
        return null;
    }
    catch (e) {
        console.error('Failed to safely parse JSON (JSON.parse error)', e);
        return null;
    }
}
export function asRequired(obj) {
    return obj;
}
//# sourceMappingURL=objects.js.map